import {CSSProperties, useRef, useState} from 'react';
import {NavLink} from 'react-router-dom';
import styled from 'styled-components';
import {useLogout} from '@/api/session';
import {useBackgroundClick, useSession} from '@/hooks';
import {paths} from '@/router';
import {palette} from '@/styles';
import {typographyStyle} from '../Typography';
import {SideElementWrapper} from './StyledComponents';

interface IProps {
  containerStyle?: CSSProperties;
}

export const UserMenu = ({containerStyle}: IProps) => {
  const {user} = useSession();
  const [open, setOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const {mutate: logout} = useLogout();

  useBackgroundClick(
    menuRef,
    () => {
      setOpen(false);
    },
    [buttonRef]
  );

  if (!user) {
    return null;
  }

  return (
    <SideElementWrapper justifyContent="end" style={containerStyle}>
      <CircleButton ref={buttonRef} onClick={() => setOpen((prev) => !prev)}>
        {user.email.slice(0, 1).toUpperCase()}
      </CircleButton>
      {open && (
        <Dropdown ref={menuRef} onClick={() => setOpen(false)}>
          <NavLink to={{pathname: paths.mypage_account}}>
            <MenuItem>개인 정보 관리</MenuItem>
          </NavLink>
          <NavLink to={{pathname: paths.mypage_pay}}>
            <MenuItem>이용 이력</MenuItem>
          </NavLink>
          <MenuItem onClick={() => logout()}>로그아웃</MenuItem>
        </Dropdown>
      )}
    </SideElementWrapper>
  );
};

const CircleButton = styled.button`
  ${{...typographyStyle.bold14}}
  border-radius: 100%;
  background-color: ${palette.gray200};
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: ${palette.gray700};
`;

const Dropdown = styled.div`
  position: absolute;
  background-color: ${palette.white};
  border-radius: 10px;
  border: solid 1px ${palette.gray200};
  right: 0;
  top: calc(100% + 8px);
  min-width: 172px;
  text-align: center;
  padding: 16px 0;
`;

const MenuItem = styled.div`
  cursor: pointer;
  ${{...typographyStyle.bold14}}
  padding: 8px;
  &:hover {
    background-color: ${palette.gray150};
  }
`;
